import { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import axios from 'axios';
import { Toaster, toast } from 'sonner';
import AdminLayout from '../../components/AdminLayout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAuthHeader = () => {
    const password = localStorage.getItem('idmat_admin');
    return {
      headers: {
        'Authorization': 'Basic ' + btoa('admin:' + password)
      }
    };
  };

  const fetchContacts = async () => {
    try {
      const response = await axios.get(`${API}/admin/contacts`, getAuthHeader());
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
      toast.error('Erreur lors du chargement des messages');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const handleDelete = async (contactId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce message ?')) return;
    
    try {
      await axios.delete(`${API}/admin/contacts/${contactId}`, getAuthHeader());
      toast.success('Message supprimé');
      fetchContacts();
    } catch (error) {
      toast.error('Erreur lors de la suppression');
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin w-8 h-8 border-4 border-[#F5C500] border-t-transparent rounded-full"></div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <Toaster position="top-right" richColors />
      <div data-testid="admin-contacts">
        <h1 
          className="text-3xl font-bold text-[#1a1a1a] mb-8"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
        >
          Messages de Contact ({contacts.length})
        </h1>

        {contacts.length === 0 ? (
          <div className="bg-white p-8 text-center text-gray-500 shadow-sm">
            Aucun message pour le moment
          </div>
        ) : (
          <div className="space-y-4">
            {contacts.map((contact) => (
              <div key={contact.id} className="bg-white p-6 shadow-sm">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-4 mb-2">
                      <h3 className="font-bold text-[#1a1a1a]">{contact.name}</h3>
                      <span className="text-sm text-gray-500">
                        {new Date(contact.created_at).toLocaleDateString('fr-FR', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mb-2">
                      <a href={`mailto:${contact.email}`} className="hover:text-[#F5C500]">
                        {contact.email}
                      </a>
                      {contact.phone && (
                        <span> • <a href={`tel:${contact.phone}`} className="hover:text-[#F5C500]">{contact.phone}</a></span>
                      )}
                    </p>
                    <p className="text-gray-700 whitespace-pre-wrap">{contact.message}</p>
                  </div>
                  <button
                    onClick={() => handleDelete(contact.id)}
                    className="p-2 hover:bg-gray-100 text-red-600"
                    title="Supprimer"
                    data-testid={`delete-contact-${contact.id}`}
                  >
                    <Trash2 size={18} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminContacts;
